import React from "react";
import ToolMenuIconButton from "./ToolMenuIconButton";
import { BsArrowClockwise } from "react-icons/bs";

export interface IProps {
  /**
   * ボタンが押された場合に呼び出されます
   */
  onClick?: () => void;
}

class ReloadButton extends React.Component<IProps> {
  render(): JSX.Element {
    return (
      <ToolMenuIconButton
        icon={<BsArrowClockwise />}
        tooltip="Reload"
        onClick={this.props.onClick}
      />
    );
  }
}

export default ReloadButton;
